module.exports = "/static/fonts/OpenSans-SemiboldItalic.woff";